export const Owners = {
    RDARRCentralOffice: {
        value: 'RDARR Central Office',
        text: 'RDARR Central Office',
    },
    BUsAndLEs: {
        value: "BU's and LE's",
        text: "BU's and LE's",
    },
    GovernanceDocumentationUnit: {
        value: 'Governance Documentation Unit',
        text: 'Governance Documentation Unit',
    },
    EnterpriseArchitecture: {
        value: 'Enterprise Architecture',
        text: 'Enterprise Architecture',
    },
    ModelValidation: {
        value: 'Model Validation',
        text: 'Model Validation',
    },
    InternalAudit: {
        value: 'Internal Audit',
        text: 'Internal Audit',
    },
    Finance: {
        value: 'Finance',
        text: 'Finance',
    },
};
